export default __webpack_public_path__ + "static/media/Grips of the Ichorous.b335ed9b.jpg";